import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore, enableIndexedDbPersistence } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDahYNAdaBBQqyQ_vgWPC0lCGLgIansiEc",
  authDomain: "gullivertravels-a4927.firebaseapp.com",
  projectId: "gullivertravels-a4927",
  storageBucket: "gullivertravels-a4927.firebasestorage.app",
  messagingSenderId: "117952134122",
  appId: "1:117952134122:web:2eb07118c4ab2710aed093"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);


enableIndexedDbPersistence(db).catch((err) => {
  if (err.code === 'failed-precondition') {
    console.log('Offline persistence unavailable: multiple tabs open');
  } else if (err.code === 'unimplemented') {
    console.log('Offline persistence not supported in this browser');
  }
});